import { TableCellTypes } from '@carboledger/ui';
import { buildCustomerSiteCertStatusVariants } from '@/config/statuses';
import { CUSTOMER_SITE_CERT_STATUS_TONE } from '@/config/statusTones';
import { CUSTOMER_SITE_COLUMNS, CUSTOMER_SITE_SORT_FIELDS } from './customers.constants';
import { makeSerialCell } from '@/components/common';
import { buildEditDeleteColumn } from './customerRowActions';

const canSort = (id) => Boolean(CUSTOMER_SITE_SORT_FIELDS[id]);

const textColumn = (id, header, width) => ({ id, header, type: TableCellTypes.text, width });

export const buildCustomerSitesColumns = (t, { serialOffset = 0, onEdit, onDelete }) =>
  [
    {
      id: CUSTOMER_SITE_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 80,
      cell: makeSerialCell(serialOffset),
    },
    {
      ...textColumn(CUSTOMER_SITE_COLUMNS.shippingTo, t('FIELD_SHIPPING_TO_SITE'), 180),
      pinnable: true,
    },
    textColumn(CUSTOMER_SITE_COLUMNS.shippingSiteId, t('FIELD_SHIPPING_SITE_ID'), 160),
    textColumn(CUSTOMER_SITE_COLUMNS.managerEmail, t('FIELD_SITE_MANAGER_EMAIL'), 220),
    textColumn(CUSTOMER_SITE_COLUMNS.managerName, t('FIELD_SITE_MANAGER_NAME'), 180),
    textColumn(
      CUSTOMER_SITE_COLUMNS.isccCertificateNumber,
      t('FIELD_ISCC_CERTIFICATE_NUMBER'),
      220,
    ),
    textColumn(CUSTOMER_SITE_COLUMNS.validTill, t('FIELD_VALID_TILL'), 120),
    {
      id: CUSTOMER_SITE_COLUMNS.status,
      header: t('FIELD_STATUS'),
      type: TableCellTypes.statusDot,
      width: 140,
      variantMap: buildCustomerSiteCertStatusVariants(t, CUSTOMER_SITE_CERT_STATUS_TONE),
    },
    textColumn(CUSTOMER_SITE_COLUMNS.addressLine1, t('FIELD_ADDRESS_LINE_1'), 200),
    textColumn(CUSTOMER_SITE_COLUMNS.addressLine2, t('FIELD_ADDRESS_LINE_2'), 200),
    textColumn(CUSTOMER_SITE_COLUMNS.city, t('FIELD_CITY_NAME'), 140),
    textColumn(CUSTOMER_SITE_COLUMNS.country, t('FIELD_COUNTRY_NAME'), 140),
    textColumn(CUSTOMER_SITE_COLUMNS.zipCode, t('FIELD_ZIP_CODE'), 110),
    buildEditDeleteColumn(t, CUSTOMER_SITE_COLUMNS.actions, { onEdit, onDelete }),
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
